export function getCurrentLocale() {
    return navigator.language || "en-US";
}
